import { useEffect } from 'react';

// Controla o bloqueio de scroll do body enquanto modais, drawers ou menus estiverem visiveis.
// Aceita um booleano ou um objeto de modal com a propriedade `visible`.
type OverflowHiddenControl = boolean | { visible?: boolean } | null | undefined;

let overflowHiddenCount = 0;

const getIsVisible = (control: OverflowHiddenControl) =>
    typeof control === 'boolean' ? control : Boolean(control?.visible);

const lockBodyOverflow = () => {
    overflowHiddenCount += 1;

    if (overflowHiddenCount === 1) {
        document.body.classList.add('bodyOverflowHidden');
    }
};

const unlockBodyOverflow = () => {
    overflowHiddenCount = Math.max(overflowHiddenCount - 1, 0);

    if (overflowHiddenCount === 0) {
        document.body.classList.remove('bodyOverflowHidden');
    }
};

const useModalOverflowHidden = (control: OverflowHiddenControl) => {
    const isVisible = getIsVisible(control);

    useEffect(() => {
        if (!isVisible) return;

        lockBodyOverflow();

        return () => {
            unlockBodyOverflow();
        };
    }, [isVisible]);
};

export default useModalOverflowHidden;
